import { Flex } from 'antd'
import { ReactElement } from 'react'

import { Text } from 'src/components'

import { useStyles } from './styles'

type Props = {
  icon: ReactElement
  detail: string
}

export const DetailsItem = ({ icon, detail }: Props) => {
  const { styles } = useStyles()

  return (
    <Flex gap={8} align="center" className={styles.detailsItem}>
      <Flex align="center">{icon}</Flex>
      <Text>{detail}</Text>
    </Flex>
  )
}
